var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.5C2.46265 0.5 0 2.96353 0 6C0 9.03824 2.46265 11.5 5.5 11.5C8.53735 11.5 11 9.03824 11 6C11 2.96353 8.53735 0.5 5.5 0.5ZM5.5 2.93952C6.01443 2.93952 6.43145 3.35654 6.43145 3.87097C6.43145 4.3854 6.01443 4.80242 5.5 4.80242C4.98557 4.80242 4.56855 4.3854 4.56855 3.87097C4.56855 3.35654 4.98557 2.93952 5.5 2.93952ZM6.74194 8.57258C6.74194 8.71955 6.62278 8.83871 6.47581 8.83871H4.52419C4.37722 8.83871 4.25806 8.71955 4.25806 8.57258V8.04032C4.25806 7.89335 4.37722 7.77419 4.52419 7.77419H4.79032V6.35484H4.52419C4.37722 6.35484 4.25806 6.23568 4.25806 6.08871V5.55645C4.25806 5.40948 4.37722 5.29032 4.52419 5.29032H5.94355C6.09052 5.29032 6.20968 5.40948 6.20968 5.55645V7.77419H6.47581C6.62278 7.77419 6.74194 7.89335 6.74194 8.04032V8.57258Z",
    fill: "#EC2D30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoDanger);
export default __webpack_public_path__ + "static/media/info-danger.a1630fa9596598d5ff4c1cc8e63aca5b.svg";
export { ForwardRef as ReactComponent };